import { AIR_DISRUPTION_ROUTE } from '../../../router/constants';
import { App } from './App';

export const AIR_DISRUPTION = {
  path: AIR_DISRUPTION_ROUTE,
  element: <App />,
};
